import { useState, useCallback } from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { VALIDATE_ACCOUNT } from "../../../operations/mutations/ResetPassword/operations/mutations/validate-account.js";
const useValidateAccount = () => {
  const [isWrongDOB, setIsWrongDOB] = useState(false);
  const onError = useCallback(
    ({ graphQLErrors, networkError }) => {
      setIsWrongDOB(true);
      return null;
    },
    [setIsWrongDOB]
  );
  const [validateAccount, { data, loading, error }] = useMutation(VALIDATE_ACCOUNT, { onError });
  const callback = (input) => {
    setIsWrongDOB(false);
    validateAccount({
      variables: {
        input
      }
    }).catch((e) => setIsWrongDOB(true));
  };
  if (data?.validateCustomerAccount.__typename === "AccountValidatedSuccessfully") {
    return [
      callback,
      {
        customerId: data?.validateCustomerAccount.customerId,
        loading,
        error,
        isWrongDOB
      }
    ];
  } else if (data?.validateCustomerAccount.__typename === "AccountValidationMaxRetriesError") {
    return [
      callback,
      {
        retries: data?.validateCustomerAccount.retries,
        loading,
        error,
        isWrongDOB
      }
    ];
  }
  return [callback, { loading, error, isWrongDOB }];
};
export {
  useValidateAccount
};
//# sourceMappingURL=use-validate-account.js.map
